import React from "react";

import LiveRate from "./LiveRate";
import ProfitLoss from "./ProfitLoss";
import { useNavigate } from "react-router-dom";
import moment from "moment";

export default function StandingCard({ item, total, isDollar }) {
  const navigate = useNavigate();

  const invester = Number(localStorage.getItem("invester"));

  return (
    <div
      onClick={() => {
        if(invester === 1) return false;
        window.symboldata = item;
        localStorage.setItem("symboldata", JSON.stringify(item));
        navigate("/BuySell");
      }}
      className="flex justify-between items-center py-1 border-b border-[var(--hover)] last:border-0"
    >
      <div>
        <span
          className={`flex items-center large font-semibold text-[var(--text)]`}
        >
          {item.symbol}.{" "}
          <div className="text-[9px] font-semibold ml-1 text-[var(--text)]">
            {item.type === "nse_cash"
              ? "Equity"
              : moment(item.expiry_date).format("DD-MMM")}
          </div>
          <span
            className={`ml-1 mr-[2px] large ${
              item.buy_sell === 0
                ? "text-[var(--buymeta)]"
                : "text-[var(--sellmeta)]"
            }`}
          >
            {item.buy_sell === 0 ? "BUY" : "SELL"} {item.qty}
          </span>
        </span>

        <div className="large flex text-[var(--subtext)]">
          {parseFloat(item.rate)}
          {" → "}
          <LiveRate symbol_id={item.symbol_id} buy_sell={item.buy_sell} />
        </div>
      </div>
      <div className={`text-right font-semibold text-[var(--text)]`}>
        <ProfitLoss
          symbol_id={item.symbol_id}
          item={item}
          total={total}
          isDollar={isDollar}
        />
      </div>
    </div>
  );
}
